import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ConversationAnalysisResultEntity } from './conversation-analysis-result.entity';
import { ConversationAnalyzerCriterionEntity } from './conversation-analyzer-criterion.entity';

@Entity('_conversation_analysis_criterion_result')
@Index(['analysisResultId', 'criterionId'])
export class ConversationAnalysisCriterionResultEntity extends BaseEntity {
	@Column({
		name: 'fk__conversation_analysis_result__id',
		type: 'int',
		unsigned: true,
	})
	public analysisResultId!: number;

	@ManyToOne(
		() => ConversationAnalysisResultEntity,
		(r) => r.criterionResults,
		{
			onDelete: 'CASCADE',
			onUpdate: 'CASCADE',
		},
	)
	@JoinColumn({ name: 'fk__conversation_analysis_result__id' })
	public analysisResult!: ConversationAnalysisResultEntity;

	@Column({
		name: 'fk__conversation_analyzer_criterion__id',
		type: 'int',
		unsigned: true,
	})
	public criterionId!: number;

	@ManyToOne(() => ConversationAnalyzerCriterionEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'CASCADE',
	})
	@JoinColumn({ name: 'fk__conversation_analyzer_criterion__id' })
	public criterion!: ConversationAnalyzerCriterionEntity;

	@Column({ name: 'raw_value', type: 'varchar', length: 50, nullable: true })
	public rawValue?: string;

	@Column({ name: 'points_earned', type: 'decimal', precision: 6, scale: 2 })
	public pointsEarned!: number;

	@Column({ name: 'max_points', type: 'decimal', precision: 6, scale: 2 })
	public maxPoints!: number;

	@Column({ name: 'weighted_score', type: 'decimal', precision: 6, scale: 2 })
	public weightedScore!: number;

	@Column({
		name: 'reasoning',
		type: 'text',
		nullable: true,
		charset: 'utf8mb4',
		collation: 'utf8mb4_0900_ai_ci',
	})
	public reasoning?: string;
}
